import React, { useMemo, useState } from 'react';
import './Kanvan.scss';
import CardKanvan from './CardKanvan';
import Card from '../../../../../../components/Atomsv2/Card/Card';
import Text from '../../../../../../components/Atomsv2/Text/Text';
import { IntegracionProyectos } from '../../../integracion';
import useGetDataUser from '../../../../../../utilidades/customHooks/useGetDataUser';

const colorPorEstatus = { 1: 'default', 2: 'warning', 3: 'primary', 4: 'neutral', 5: 'success', 6: 'error' };

const Kanvan = ({ data, setData, onCardClick, filtros, setFiltros }) => {
    const userData = useGetDataUser();
    const [draggedTarea, setDraggedTarea] = useState(null);
    const [dragOverStatus, setDragOverStatus] = useState(null);

    const estatusCompletadaId = useMemo(() => {
        const lista = filtros?.estatus || data.estatus || [];
        const found = lista.find(e =>
            ['COMPLET', 'TERMIN', 'FINALIZ'].some(w =>
                String(e.ESTATUS ?? e.name ?? e.label ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(w)
            )
        );
        return found?.ID ?? found?.value;
    }, [filtros?.estatus, data.estatus]);

    const handleDragStart = (tarea) => setDraggedTarea(tarea);
    const handleDragEnd = () => setDraggedTarea(null);

    const handleDrop = async (col) => {
        setDragOverStatus(null);
        if (!draggedTarea || draggedTarea.ESTATUS_ID === col.id) return;
        // Bloquear drop si la tarea tiene bloqueantes activos
        try {
            const bloqueantes = JSON.parse(draggedTarea.TAREAS_BLOQUEANTES || '[]');
            const tieneBlocanteActivo = bloqueantes.some(b => {
                const tareaBloc = (data.tareas || []).find(t => t.ID === b.ID);
                return !estatusCompletadaId || !tareaBloc || tareaBloc.ESTATUS_ID !== estatusCompletadaId;
            });
            if (tieneBlocanteActivo) { setDraggedTarea(null); return; }
        } catch { }
        const params = {
            id: draggedTarea.ID,
            tarea: draggedTarea.TAREA,
            descripcion: draggedTarea.DESCRIPCION,
            id_proyecto: draggedTarea.PROYECTO_ID,
            estatus_id: col.id,
            prioridad_id: draggedTarea.PRIORIDAD_ID,
            id_sprint: draggedTarea.SPRINT_ID,
            fecha_ini: draggedTarea.FECHA_INI?.split('T')[0],
            fecha_fin: draggedTarea.FECHA_FIN?.split('T')[0],
            id_usuario_modificacion: draggedTarea.USUARIO_MODIFICACION_ID ?? userData?.user?.ID,
            id_usuario_asignado: draggedTarea.USUARIO_ASIGNADO_ID,
        };
        await IntegracionProyectos.updateTarea(params);

        // Al completarse, se elimina el vínculo de bloqueo en las tareas que dependen de ella
        const desbloqueadas = [];
        if (estatusCompletadaId && col.id === estatusCompletadaId) {
            for (const t of (data.tareas || [])) {
                let vinculo = null;
                try { vinculo = JSON.parse(t.TAREAS_BLOQUEANTES || '[]').find(b => b.ID === draggedTarea.ID); }
                catch { vinculo = null; }
                if (!vinculo) continue;
                try {
                    await IntegracionProyectos.deleteTareaBloqueante({ id: vinculo.ID });
                    desbloqueadas.push(t.ID);
                } catch { /* propagación best-effort */ }
            }
        }

        setData(prev => ({
            ...prev,
            tareas: prev.tareas.map(t => {
                if (t.ID === draggedTarea.ID) return { ...t, ESTATUS_ID: col.id, ESTATUS: col.nombre };
                if (!desbloqueadas.includes(t.ID)) return t;
                let restantes = [];
                try { restantes = JSON.parse(t.TAREAS_BLOQUEANTES || '[]').filter(b => b.ID !== draggedTarea.ID); }
                catch { restantes = []; }
                return { ...t, TAREAS_BLOQUEANTES: JSON.stringify(restantes) };
            })
        }));
        setDraggedTarea(null);
    };


    return (
        <div className='Kanvan'>
            <Card  >
                <div className='kanvan-card' >
                    <div className='kanvan-grid'>
                        {(filtros?.estatus || []).map(est => {
                            const estatusId = est.ID ?? est.value;
                            const estatusNombre = est.ESTATUS ?? est.name ?? est.label;
                            const col = { id: estatusId, nombre: estatusNombre, color: colorPorEstatus[estatusId] || 'default' };
                            // excluir subtareas del tablero
                            const tareas = data?.tareas?.filter(t => t.ESTATUS_ID === estatusId && !t.TAREA_PRINCIPAL_ID) || [];
                            return (
                                <div
                                    key={estatusId}
                                    className={`kanvan-col${dragOverStatus === estatusId ? ' drag-over' : ''}`}
                                    onDragOver={e => { e.preventDefault(); setDragOverStatus(estatusId); }}
                                    onDragLeave={() => setDragOverStatus(null)}
                                    onDrop={() => handleDrop(col)}
                                >
                                    <div className='kanvan-header'>
                                        <div className='kanvan-header-left'>
                                            <div className={`punto color-${col.color}`} />
                                            <Text size='extra-small' weight='600'>{estatusNombre}</Text>
                                        </div>
                                        <div className='contador'>{tareas.length}</div>
                                    </div>
                                    {tareas.map(tarea => (
                                        <CardKanvan
                                            key={tarea.ID}
                                            data={tarea}
                                            onDragStart={handleDragStart}
                                            onDragEnd={handleDragEnd}
                                            onClick={onCardClick}
                                            isDragging={draggedTarea?.ID === tarea.ID}
                                            allTareas={data.tareas}
                                            estatusCompletadaId={estatusCompletadaId}
                                        />
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Card>
        </div>
    );
};
export default Kanvan;